import React from 'react';
import { Space } from 'antd';
import { PaperPlaneTilt } from '@phosphor-icons/react';
// import { iconWarnnig } from 'utils/importFile';
import { ToolbarInvoiceProps } from 'types/invoice.type';
import ToolbarLayout from './ToolbarLayout';
import { ButtonCommon } from '../Button/ButtonCommon';
// import { formatPrice } from 'utils';

const ToolbarInvoice: React.FC<ToolbarInvoiceProps> = ({
  customerName,
  loading,
  onSubmit,
  onCancel,
  replaceInvoice,
}) => {
  const left = (
    <Space align='center' className='gap-[24px] flex-wrap'>
      {customerName && (
        <Space align='center' className='gap-[12px]'>
          <p className='text-[var(--textBlack56)]' style={{ fontSize: '13px' }}>
            Tên KH:
          </p>
          <span className='text-[var(--textBlack80)] text-[13px] font-medium'>{customerName}</span>
        </Space>
      )}

      {/* <img src={iconWarnnig} width={18} height={18} alt='icon warning' />

      <Space size='small' align='center' className='text-[13px] 2xl:text-sm'>
        <p>Tổng tiền : {formatPrice(Number(total))} VNĐ</p>
      </Space> */}
    </Space>
  );

  const right = (
    <Space className='gap-[4px]'>
      <ButtonCommon
        color='basic'
        fullWidth
        radius='rounded'
        size='md'
        className='bg-white pl-0 text-black'
        onClick={onCancel}
        style={{ paddingLeft: 0 }}
      >
        Huỷ
      </ButtonCommon>
      {!replaceInvoice?.id && (
        <ButtonCommon
          color='basic'
          fullWidth
          loading={loading}
          radius='rounded'
          size='md'
          className='bg-[var(--bgBlackOpacity)] px-3 gap-2 text-black'
          onClick={() => onSubmit(0)}
        >
          <div>Lưu bản nháp</div>
        </ButtonCommon>
      )}
      <ButtonCommon
        color='basic'
        fullWidth
        loading={loading}
        radius='rounded'
        size='md'
        className='bg-[var(--primaryColor500)] px-3 gap-2'
        onClick={() => onSubmit(1)}
      >
        <div className='w-5 h-5 hidden-toolbar-customer'>
          <PaperPlaneTilt size={20} />
        </div>
        <div>{replaceInvoice?.id ? 'Tạo hoá đơn điện tử thay thế' : 'Tạo hoá đơn điện tử mới'}</div>
      </ButtonCommon>
    </Space>
  );

  return <ToolbarLayout left={left} right={right} className='rounded-lg shadow ' />;
};

export default ToolbarInvoice;
